module.exports = __webpack_public_path__ + "static/media/double_arrow_gray.0bf1c9af.svg";